<template>
  <div class="" style="padding: 3px">
    关于计算的知识 —— 这些其他人也都能学到，不论是学会使用一门编程语言，写一个健壮的、好用的库，
    写一个前端后端编译器，甚至编写自己的编程语言和操作系统，数据库系统等。
    成功计算的钥匙并不掌握在某个程序员手上，我们需要掌握的并且应该掌握的，
    是一种智慧：<b>看到机器比第一次站在它面前时能做的更多的能力</b>。
  </div>
<!--  <div class="card-columns" id="tech">
&lt;!&ndash;    <div class="card" v-for="(card, index) in cards" :key="index">
      <img class="card-img-top" :src="card['image']" :alt="card['title']" v-if="card['image'] !== undefined">
      <div class="card-body" v-if="card['justCard'] === undefined">
        <h5 class="card-title" v-if="card['title'] !== undefined">{{card['title']}}</h5>
        <p class="card-text" v-if="card['label'] !== undefined">
          <span class="badge badge-pill badge-info label" v-for="(c, c_index) in card['label']" :key="index + c_index">{{c}}</span>
        </p>
        <p v-else class="card-text"></p>
        <p class="card-text afterBadge" v-if="card['intro'] !== undefined">{{card['intro']}}</p>
        <p class="card-text">
        <a :href="card['website']" class="card-link more" v-if="card['website'] !== undefined">↩</a>
        <a :href="card['note']" class="card-link more2" v-if="card['note'] !== undefined">📖</a>
        <small class="text-muted"  v-if="card['footer'] !== undefined">{{card['footer']}}</small></p>
      </div>
    </div>&ndash;&gt;

  </div>-->
</template>

<script>
export default {
  name: "Tech",
  data() {
      return {
        //image, title, intro, website, note
        cards: [
          {
            image: "/static/tech/java.png",
            title: "Java",
            label: ["Echo System", "OOP", "JVM"],
            /*intro: "Java is at the heart of our digital lifestyle. It's the platform for launching careers, exploring human-to-digital interfaces, " +
              "architecting the world's best applications, and unlocking innovation everywhere—from garages to global organizations.",
            */website: "https://go.java/index.html",
            note: "#",
            footer: "3 年使用经验",
          },
          {
            image: "/static/tech/scala.png",
            title: "Scala",
            /*intro: "Scala combines object-oriented and functional programming in one concise, " +
              "high-level language. Scala's static types help avoid bugs in complex applications, " +
              "and its JVM and JavaScript runtimes let you build high-performance systems with easy access " +
              "to huge ecosystems of libraries.",
            */label: [
              "Functional", "OOP", "JVM"
            ],
            footer: "2 年使用经验",
            website: "http://www.scala-lang.org",
            note: "#"
          },
          {
            image: "/static/tech/dart.png",
            title: "Dart",
            //intro: "Dart is a client-optimized language for fast apps on any platform",
            label: [
              "Flexible", "Simple", "Modern", "UI"
            ],
            website: "https://dart.dev",
            note: "#",
            footer: "",
          },
          {
            image: "/static/tech/javascript.png",
            title: "JavaScript",
            /*intro: "JavaScript is a prototype-based, multi-paradigm, " +
              "dynamic language, supporting object-oriented, imperative, and  functional programming styles.",
            */label: [
              "Web", "Echo System"
            ],
            website: "https://developer.mozilla.org/zh-CN/docs/Web/JavaScript",
            note: "#",
            footer: "",
          },
          {
            image: "/static/tech/typescript.png",
            title: "TypeScript",
            /*intro: "TyeScript is a typed superset of JavaScript that compiles to plain JavaScript. " +
              "Any browser. Any host. Any OS. Open source.",
            */label: [
              "Web", "Echo System", "Typed"
            ],
            website: "https://www.typescriptlang.org/",
            note: "#",
            footer: "",
          },
          {
            image: "/static/tech/python.png",
            title: "Python",
            label: ["Fast", "Simplify"],
            note: "#",
            footer: "3 年使用经验",
            website: "http://python.org"
          },
          {
            image: "/static/tech/swift.png",
            justCard: true
          },
          {
            image: "/static/tech/spring.png",
            justCard: true
          },
          {
            image: "/static/tech/shiro.png",
            justCard: true
          },
          {
            image: "/static/tech/javafx.png",
            justCard: true,
            title: "JavaFx",
            label: ["GUI"],
            website: "https://openjfx.io/",
            note: "#",
            footer: "3 年使用经验",
          },
          {
            image: "/static/tech/hibernate.png",
            justCard: true,
            title: "Hibernate and JPA",
            label: ["ORM"],
            note: "#",
            footer: "3 年使用经验",
          },

          {
            image: "/static/tech/flutter.png",
            justCard: true
          },

          {
            image: "/static/tech/vue.png",
            justCard: true
          },
          {
            image: "/static/tech/qt.png",
            justCard: true
          },
          {
            image: "/static/tech/mysql.png",
            justCard: true
          },
          {
            image: "/static/tech/mongodb.png",
            justCard: true
          },
          {
            image: "/static/tech/maven.png",
            justCard: true
          },
          {
            image: "/static/tech/akka.png",
            justCard: true
          },
          {
            image: "/static/tech/matplotlib.png",
            justCard: true
          },
          {
            image: "/static/tech/pandas.png",
            justCard: true
          },




        ]
      }
  },
}
</script>

<style scoped>
#tech {
  margin-left: -18px;
  margin-right: -13px;
}
.more {
  display: block;
  float: right;
  margin-right: 0;
  padding-bottom: 15px;
}
.more2 {
  display: block;
  float: right;
  margin-right: 10px;
  padding-bottom: 15px;
}
.label {
  margin-right: 6px;
}
.afterBadge {
  margin-top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tech.vue